import React from 'react';

// English translations
export const englishTranslations = {
  // ========== NAVIGATION & LAYOUT ==========
  title: "Duelity Gaming Tournament Platform",
  welcome: "Welcome",
  points: "Points",
  logout: "Logout",
  tournaments: "Tournaments",
  pointsProfile: "Points & Profile",
  matchHistory: "Match History",
  adminPanel: "Admin Panel",
  approverPanel: "Approver Panel",
  supervisorPanel: "Supervisor Panel",
  managerPanel: "Manager Panel",
  login: "Login",
  register: "Register here",
  myProfile: "My Profile",
  dontHaveAccount: "Don't have an account?",
  language: "Language",
  liveChat: "Live Chat",
  menu: "Menu",
  publicProfile: "PUBLIC",
  levelsBadges: "Level & Badges",

  // ========== AUTHENTICATION ==========
  username: "Username",
  password: "Password",
  email: "Email",
  inGameName: "In-Game Name",
  backToLogin: "Back to Login",
  createAccount: "Create Account",
  loginSuccessful: "Login successful!",
  welcomeBattlefield: "Welcome to the battlefield!",
  registrationSuccessful: "Registration successful!",
  logoutSuccessful: "Logged out successfully",
  loggingIn: "Logging in...",
  creatingAccount: "Creating Account...",

  // ========== AUTH VALIDATION ==========
  loginSubtitle: "Sign in to your account",
  fillAllFields: "Fill in all fields to create your account",
  enterUsername: "Enter your username",
  enterPassword: "Enter your password",
  enterEmail: "Enter your email address",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "Re-enter your password",
  confirmPassword: "Confirm Password",

  // Validation errors
  usernameRequired: "Username is required",
  usernameTooShort: "Username must be at least 3 characters",
  usernameTooLong: "Username must be less than 20 characters",
  usernameNoHebrew: "Username cannot contain Hebrew characters",
  usernameNoArabic: "Username cannot contain Arabic characters",
  usernameInvalidChars: "Username can only contain letters, numbers, underscore and dash",
  emailRequired: "Email is required",
  emailInvalid: "Please enter a valid email address",
  inGameNameRequired: "In-game name is required",
  inGameNameTooShort: "In-game name must be at least 2 characters",
  inGameNameTooLong: "In-game name must be less than 30 characters",
  passwordRequired: "Password is required",
  passwordTooShort: "Password must be at least 6 characters",
  passwordTooLong: "Password must be less than 50 characters",
  passwordNeedsNumber: "Password must contain at least one number",
  passwordNeedsLetter: "Password must contain at least one letter",
  confirmPasswordRequired: "Please confirm your password",
  passwordsDoNotMatch: "Passwords do not match",

  // Validation success
  usernameValid: "Username is valid",
  emailValid: "Email is valid",
  inGameNameValid: "In-game name is valid",
  passwordValid: "Password is valid",
  passwordsMatch: "Passwords match",

  // Password requirements
  min6Chars: "At least 6 characters",
  hasLetter: "Contains a letter",
  hasNumber: "Contains a number",

  // Login errors
  invalidCredentials: "Invalid username or password",
  userNotFound: "User not found. Please check your username.",
  wrongPassword: "Incorrect password. Please try again.",
  accountDisabled: "Your account has been disabled. Contact support.",
  loginFailed: "Login failed. Please try again.",
  registrationFailed: "Registration failed. Please try again.",

  
  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "Forgot password?",
  forgotPasswordTitle: "Forgot Password",
  forgotPasswordSubtitle: "Enter your email address and we will send you a link to reset your password.",
  sendResetLink: "Send Reset Link",
  sending: "Sending...",
  checkYourEmail: "Check Your Email",
  resetLinkSent: "If an account with that email exists, you will receive a password reset link shortly. Please also check your spam folder.",
  linkExpiresIn: "The link will expire in 1 hour.",
  resetPassword: "Reset Password",
  resetPasswordTitle: "Reset Password",
  resetPasswordSubtitle: "Enter your new password below.",
  newPassword: "New Password",
  confirmNewPassword: "Confirm Password",
  enterNewPassword: "Enter new password",
  confirmNewPasswordPlaceholder: "Confirm new password",
  resetting: "Resetting...",
  passwordResetSuccess: "Password Reset!",
  passwordResetSuccessMessage: "Your password has been successfully reset.",
  redirectingToLogin: "Redirecting to login page...",
  loginNow: "Login Now",
  invalidResetLink: "Invalid Link",
  invalidResetLinkMessage: "This password reset link is invalid or has expired.",
  resetLinkExpiredNote: "Reset links expire after 1 hour for security.",
  requestNewResetLink: "Request New Reset Link",
  verifyingResetLink: "Verifying reset link...",

// ========== LEVEL SYSTEM CORE ==========
  level: "Level",
  levels: "Levels",
  experience: "Experience", 
  exp: "EXP",
  totalExp: "Total EXP",
  expNeeded: "EXP needed",
  expToNext: "EXP to next level",
  expGained: "EXP Gained",
  expReward: "EXP Reward",
  currentLevel: "Current Level",
  nextLevel: "Next Level",
  maxLevel: "MAX LEVEL!",
  levelUp: "LEVEL UP!",
  levelProgress: "Level Progress",
  levelSystem: "Level System",
  loadingLevel: "Loading level...",
  levelTooltip: "Level {level} - {title}\n{totalExp} total EXP\n{remaining}",
  
  // ========== LEVEL TITLES ==========
  beginner: "Beginner",
  novice: "Novice", 
  intermediate: "Intermediate",
  advanced: "Advanced",
  professional: "Professional",
  expert: "Expert",
  master: "Master",
  grandmaster: "Grandmaster",
  mythic: "Mythic",
  sage: "Sage",
  legend: "Legend",
  
  // ========== BADGES SYSTEM ==========
  badges: "Badges",
  badge: "Badge",
  earnedBadges: "Earned",
  inProgress: "In Progress",
  allBadges: "All",
  loadingBadges: "Loading badges...",
  noBadges: "No badges yet",
  badgeUnlocked: "Badge Unlocked!",
  badgeProgress: "Badge Progress",
  badgeModal: "Badge Details",
  comingSoon: "Coming Soon",
  systemLoading: "System loading...",
  noBadgesYet: "No badges yet",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% complete",
  currentProgress: "Current Progress",
  
  // ========== BADGE CATEGORIES ==========
  allCategories: "All Categories",
  winStreak: "Win Streak",
  filler: "Filler",
  totalWins: "Total Wins",
  pointsWinning: "Points Winning",
  pointsPurchase: "Points Purchase",
  multiplayer: "Multiplayer",
  battleRoyale: "Battle Royale",
  multiplayerWins: "Multiplayer Wins",
  battleRoyaleWins: "Battle Royale Wins",
  
  // ========== BADGE RARITIES ==========
  common: "Common",
  rare: "Rare", 
  epic: "Epic",
  legendary: "Legendary",
  
  // ========== BADGE MODAL ==========
  close: "Close",
  category: "Category",
  requirement: "Requirement",
  unlocked: "Unlocked",
  unlockedOn: "Unlocked On",
  progress: "Progress",
  remaining: "remaining",
  tip: "Tip",
  gotIt: "Got it!",
  
  // ========== PROGRESS INDICATORS ==========
  complete: "Complete",
  completion: "Completion",
  showMore: "Show More",
  showLess: "Show Less",
  upcoming: "Upcoming",
  upcomingMilestones: "Upcoming Milestones",
  congratsMaxLevel: "Congratulations! You've reached the maximum level!",
  totalExpEarned: "Total EXP earned",
  progressDetails: "Progress Details",
  expForCurrentLevel: "EXP for current level",
  expForNextLevel: "EXP for next level",
  progressToNext: "Progress to next level",
  
  // ========== STATUS INDICATORS ==========
  loading: "Loading...",
  loadingProgress: "Loading progress...",
  offline: "Offline",
  online: "Online",
  
  // ========== BADGE TIPS ==========
  winStreakTip: "Keep winning games consecutively to reach this milestone! You need {remaining} more wins in a row.",
  totalWinsTip: "Win more tournaments to unlock this badge. {remaining} victories to go!",
  pointsWinningTip: "Earn more points from winning tournaments. You need {remaining} more points.",
  pointsPurchaseTip: "Purchase more points to unlock this badge. {remaining} points left to buy.",
  fillerTip: "Add filler players to tournaments and hope they win! {remaining} more filler wins needed.",
  multiplayerTip: "Play more multiplayer tournaments. {remaining} games remaining.",
  battleRoyaleTip: "Participate in more Battle Royale matches. {remaining} games to go.",
  multiplayerWinsTip: "Win more multiplayer tournaments. {remaining} victories needed.",
  battleRoyaleWinsTip: "Win more Battle Royale matches. {remaining} wins to unlock.",
  genericTip: "Keep playing to unlock this badge! {remaining} more to go.",
  
  // ========== LEVEL UP NOTIFICATIONS ==========
  levelUpNotification: "Level Up!",
  levelUpTitle: "Congratulations!",
  levelUpSubtitle: "You've reached a new level!",
  newLevelUnlocked: "New level unlocked",
  titleEarned: "Title earned",
  
  // ========== STATISTICS ==========
  statistics: "Statistics",
  totalEarned: "Total Earned",
  totalAvailable: "Total Available", 
  completionPercentage: "Completion Percentage",
  earnedCount: "Earned Count",
  progressCount: "In Progress Count",
  
  // ========== ACHIEVEMENT MESSAGES ==========
  achievementUnlocked: "Achievement Unlocked!",
  newBadgeEarned: "New Badge Earned!",
  levelMilestone: "Level Milestone!",
  experienceGained: "Experience gained: +{amount}",
  
  // ========== ERROR MESSAGES ==========
  failedToLoadBadges: "Failed to load badges",
  failedToLoadLevel: "Failed to load level",
  failedToLoadProgress: "Failed to load progress",
  
  // ========== ACTION BUTTONS ==========
  viewDetails: "View Details",
  trackProgress: "Track Progress",
  shareAchievement: "Share Achievement",
  
  // ========== NOTIFICATIONS ==========
  badgeEarned: "Badge earned: {badgeName}",
  levelIncreased: "Level up! Now level {level}",
  milestoneReached: "Milestone reached!",
  
  // ========== COMPACT DISPLAYS ==========
  lvl: "Lvl",
  expShort: "EXP",
  badgesShort: "Badges",
  
  // ========== PROGRESS BARS ==========
  progressBarLabel: "Progress: {current}/{total}",
  completionRate: "Completion rate: {percentage}%",
  
  // ========== TIME-BASED ==========
  recentlyUnlocked: "Recently unlocked",
  timeToUnlock: "Time to unlock",
  earnedToday: "Earned today",
  earnedThisWeek: "Earned this week",
  
  // ========== FILTERS AND SORTING ==========
  filterByCategory: "Filter by category",
  sortByProgress: "Sort by progress",
  sortByRarity: "Sort by rarity",
  sortByDate: "Sort by date",
  
  // ========== HELP TEXT ==========
  howToEarnBadges: "How to earn badges",
  levelSystemExplanation: "Level system explanation",
  experienceExplanation: "Experience points explanation",
  
  // ========== SPECIAL EVENTS ==========
  specialEvent: "Special Event",
  limitedTime: "Limited Time",
  eventBadge: "Event Badge",
  seasonalBadge: "Seasonal Badge",

  // ========== PUBLIC PROFILE TRANSLATIONS ==========
  profileTitle: "{name}'s Profile",
  playerNotFound: "Player not found",
  profilePrivate: "This profile is private",
  failedToLoadProfile: "Failed to load profile",
  playerNotFoundDesc: "The player you're looking for doesn't exist or has been banned.",
  profilePrivateDesc: "This player has made their profile private.",
  profileLoadError: "There was an error loading the profile. Please try again.",
  yourProfile: "Your Profile",
  searchOtherPlayer: "Search for another player",
  findPlayer: "Find a Player",
  searchPlayerDesc: "Search for any player by their username or in-game name to view their public profile.",
  loadingProfile: "Loading Profile...",
  loadingPlayerProfile: "Loading player profile...",
  playerProfiles: "Player Profiles",
  
  // ========== LEADERBOARD TRANSLATIONS ==========
  wins:"Wins",
  avgPrize:"Average",
  totalPrize: "Total Prize",
  losses: "Losses",
  leaderboard: "Leaderboard",
  levelLeaderboard: "Level Leaderboard",
  winsLeaderboard: "Wins Leaderboard", 
  winStreakLeaderboard: "Win Streak Leaderboard",
  pointsLeaderboard: "Points Leaderboard",
  levelLeaderboardDesc: "Top players ranked by experience points and level",
  winsLeaderboardDesc: "Top players ranked by total tournament wins",
  winStreakLeaderboardDesc: "Top players with current win streaks",
  pointsLeaderboardDesc: "Top players ranked by current points balance",
  loadingLeaderboard: "Loading Leaderboard...",
  loadingRankings: "Loading player rankings...",
  failedToLoadLeaderboard: "Failed to load leaderboard",
  leaderboardRefreshed: "Leaderboard refreshed!",
  leaderboardLoadError: "There was an error loading the leaderboard. Please try again.",
  noDataAvailable: "No Data Available",
  noActiveStreaks: "No players currently have active win streaks.",
  noPlayersFound: "No players found for this leaderboard.",
  fullRankings: "Full Rankings",
  champion: "Champion",
  currentStreak: "Current Streak",
  maxStreak: "Max",
  levelDesc: "By Experience",
  winsDesc: "By Victories",
  winStreakDesc: "Current Streaks",
  pointsDesc: "By Balance",
  lastUpdated: "Last updated",
  accountAge: "Account age ",
  days: "days",
  you: "(You)",
  searchFromLeaderboard: "Search any player...",
  
  // ========== ENHANCED PROFILE COMPONENTS ==========
  profile: "Profile",
  overview: "Overview",
  mainAdmin: "Main Admin",
  supervisor: "Supervisor",
  approver: "Approver",
  manager: "Manager",
  verifiedSponsor: "Verified Sponsor",
  player: "Player",
  memberSince: "Member Since ",
  lastSeen: "Last Seen",
  currentlyOnline: "Currently:",
  fillerWins: "Filler Wins",
  bestWinStreak: " Best Win Streak",
  gameModeStats: "Game Mode Statistics",
  accountInformation: "Account Information",
  funStats: "Fun Statistics",
  played: "Played",
  multiplayerWinRate: "Multiplayer Win Rate",
  battleRoyaleWinRate: "Battle Royale Win Rate",
  
  // ========== SEARCH AND GENERAL ==========
  search: "Search",
  searchForPlayer: "Search for a Player",
  searchPlayerPlaceholder: "Search by username or in-game name...",
  searching: "Searching...",
  playersFound: "players found",
  noPlayersFoundSearch: "No players found matching \"{query}\"",
  searchTipExact: "Try searching with the exact username or in-game name",
  searchTipUsername: "Search by username (e.g., @player123)",
  searchTipInGame: "Search by in-game name (e.g., ProGamer)",
  searchTip: "Use ↑↓ to navigate, Enter to select, Esc to close",
  
  // ========== BADGES AND PROFILE SPECIFIC ==========
  badgeCollection: "Badge Collection",
  earned: "Earned",
  categoryBreakdown: "Category Breakdown",
  achievementSummary: "Achievement Summary",
  badgeSystemNotAvailable: "The badge system is not available for this profile.",
  badgesPrivateDesc: "This player has made their badge collection private.",
  badgesLoadError: "There was an error loading the badge collection.",
  badgeSummaryText: "has earned {earned} out of {total} available badges ({percentage}% completion). They have unlocked {categories} different categories and gained a total of {exp} experience points from badges.",
  recentlyEarned: "Recently Earned",
  showProgress: "Show Progress",
  categoriesUnlocked: "Categories",
  totalExpFromBadges: "Total EXP from Badges",
  
  // ========== MATCH HISTORY ==========
  noMatches: "No Matches Found",
  noMatchesDesc: "This player hasn't completed any public matches yet.",
  loadingMatches: "Loading matches...",
  total: "Total",
  prizeWon: "Prize Won",
  winRate: "Win Rate",
  map: "Map",
  maxKills: "Max Kills",
  entry: "Entry",
  prize: "Prize",
  players: "Players",
  by: "by",
  won: "WON",
  lost: "LOST",
  shared: "Shared",
  thisPlayer: "This Player",
  matchSummary: "Match Summary",
  winLossRecord: "Win/Loss Record",
  totalPrizeWon: "Total Prize Won",
  averagePrize: "Average Prize per Win",
  
  // ========== DETAILED STATISTICS ==========
  detailedStatistics: "Detailed Statistics",
  quickStats: "Quick Stats",
  overallPerformance: "Overall Performance",
  gameModeBreakdown: "Game Mode Breakdown",
  pointsStatistics: "Points Statistics",
  specialAchievements: "Special Achievements",
  playerSummary: "Player Summary",
  playerSummaryText: "is a {performance} player with {wins} wins out of {total} matches, achieving a {winRate}% win rate. They are currently ranked #{rank} globally.",
  currentStreakText: "They are currently on a {streak} win streak!",
  bestStreakText: "Their best win streak was {streak} consecutive wins.",
  elite: "Elite",
  pro: "Pro",
  average: "Average",
  fillerMaster: "Filler Master",
  fillerWinsDesc: "Won tournaments with AI fillers",
  streakWarrior: "Streak Warrior",
  streakDesc: "Achieved impressive win streaks",
  globalRank: "Global Rank",
  byExperience: "By Experience",
  currentPoints: "Current Points",
  pointsWon: "Points Won",
  pointsLost: "Points Lost",
  netGain: "Net Gain",
  avgPerWin: "Avg per win",
  fromLosses: "From losses",
  pointsPurchased: "Points Purchased",
  teamBased: "Team-based matches",
  survivalMode: "Survival mode",
  matchesPlayed: "Matches Played",
  totalMatches: "Total Matches",
  badgesEarned: "Badges Earned",
  badgeExp: "Badge EXP",
  categories: "Categories",
  
  // ========== ROLES ==========
  roleChanged: "Your role has been changed",
  commissionEarned: "Commission Earned",
  matchesApproved: "Matches Approved",
  approversManaged: "Approvers Managed",
  roleUpdated: "Role Updated",
  roleChangedTo: "Your role has been changed to",
  changedBy: "Changed by",
  reason: "Reason",
  commissionRates: "Commission Rates",
  
  // ========== TOURNAMENT CLEANUP TRANSLATIONS ==========
  oldTournamentRemoved: 'Old tournament automatically removed',
  tournamentsAutoRemoved: '{count} old tournament(s) removed from lobby',
  pointsRefunded: '{amount} points refunded to players',
  adminCleanupActivity: 'Cleanup: {deleted} tournaments removed, {refunded} points refunded',
  manualCleanupTriggered: 'Manual cleanup by {admin}: {deleted} tournaments deleted',
  autoCleanup: 'Auto-Cleanup',
  removes: 'Removes',
  old: 'old',
  cleanupNow: 'Cleanup Now',
  active: 'Active',
  stopped: 'Stopped',
  onlyMainAdminCanCleanup: 'Only main admins can trigger manual cleanup',
  manualCleanupCompleted: 'Manual cleanup completed: {deleted} tournaments removed',
  manualCleanupFailed: 'Manual cleanup failed',
  tournamentAutoDeleted: 'Tournament automatically deleted due to age',
  tournamentDeletedOld: 'Old tournament removed from lobby',
  cleanupServiceActive: 'Cleanup service is active',
  cleanupServiceStopped: 'Cleanup service is stopped',
  tournamentCleanupStatus: 'Tournament Cleanup Status',
  maxAgeInLobby: 'Max age in lobby',
  cleanupInterval: 'Cleanup interval',
  lastCleanup: 'Last cleanup',
  nextCleanup: 'Next cleanup',
  tournamentsProcessed: 'Tournaments processed',
  totalRefundedAmount: 'Total refunded',
  cleanupConfiguration: 'Cleanup Configuration',
  enableAutoCleanup: 'Enable automatic cleanup',
  maxAgeHours: 'Maximum age (hours)',
  intervalMinutes: 'Cleanup interval (minutes)',
  maxPerRun: 'Max tournaments per run',
  enableNotifications: 'Enable notifications',
  saveConfiguration: 'Save Configuration',
  configurationSaved: 'Configuration saved successfully',
  configurationFailed: 'Failed to save configuration',
  triggerManualCleanup: 'Trigger Manual Cleanup',
  cleanupInProgress: 'Cleanup in progress...',
  cleanupCompleted: 'Cleanup completed',
  noOldTournaments: 'No old tournaments found',
  cleanupSummary: 'Cleanup Summary',
  deletedCount: 'Deleted',
  refundedAmount: 'Refunded',
  errors: 'Errors',
  duration: 'Duration',
  tournamentAgeWarning: 'Tournament will be auto-deleted in {time}',
  tournamentAgeInfo: 'Tournament age: {age}',
  autoDeleteIn: 'Auto-delete in',
  minutes: 'minutes',
  hours: 'hours',
  
  // ========== FILLER MANAGEMENT ==========
  addFiller: "Add Filler",
  fillerManagement: "FILLER MANAGEMENT",
  fillerPlayers: "Filler Players",
  fillerName: "Filler Player Name",
  enterFillerName: "Enter filler name...",
  fillerNameRequired: "Filler name is required",
  fillerNameTooLong: "Filler name too long (max 20 characters)",
  fillerNameHelp: "Choose a unique name for this AI player (max 20 characters)",
  insufficientPointsForFiller: "Insufficient points to add filler",
  fillerAddedSuccessfully: "Filler \"{name}\" added successfully!",
  failedToAddFiller: "Failed to add filler",
  removeFiller: "Remove filler",
  fillerRemoved: "Filler removed successfully!",
  fillerRemovedWithRefund: "Filler removed! {amount} points refunded.",
  failedToRemoveFiller: "Failed to remove filler",
  yourFiller: "(Your Filler)",
  needMorePoints: "Need {amount} more points",
  needMoreRealPlayers: "Need {count} more real player(s) before adding fillers when tournament becomes full",
  needRealPlayersWarning: "Need {count} more real player(s) to add fillers when tournament becomes full",
  free: "FREE",
  cost: "Cost",
  slots: "Slots",
  slotRemaining: "slot remaining",
  slotsRemaining: "slots remaining",
  giveawayFillerFree: "This is a giveaway tournament - fillers are FREE!",
  fillerCostWarning: "You will pay {cost} points for this filler. If the filler wins, you get the prize!",
  fillerAddedAndTournamentUpdated: "Filler added! Tournament updated.",
  
  // ========== COPY FUNCTIONALITY ==========
  noMatchIdToCopy: "No Match ID available to copy",
  matchIdCopied: "Match ID copied to clipboard!",
  noTournamentIdToCopy: "No Tournament ID available to copy",
  tournamentIdCopied: "Tournament ID copied to clipboard!",
  
  // ========== SEARCH AND PAGINATION ==========
  searchFinishedTournaments: "Search by Tournament ID, Creator, Game Mode, or Map...",
  searchResultsCount: "Found {count} tournaments",
  noSearchResults: "NO SEARCH RESULTS",
  tryDifferentSearch: "Try a different search term or clear the search",
  previousPage: "Previous page",
  nextPage: "Next page",
  prev: "Prev",
  next: "Next",
  pageInfo: "Page {current} of {total} ({totalItems} total)",
  
  // ========== ADMIN PANEL ==========
  mainAdminPanel: "Main Admin Panel",
  commissionSummary: "Commission Summary",
  yourCommissionEarned: "Your Commission Earned",
  asSupervisor: "(as Supervisor)",
  asApprover: "(as Approver)",
  totalFromUsers: "Total from Users",
  totalToApprovers: "Total to Approvers",
  totalToSystem: "Total to System",
  
  // ========== ADMIN TABS ==========
  stats: "Stats",
  roles: "Roles",
  pointsTab: "Points",
  rates: "Rates",
  users: "Users",
  approvers: "Approvers",
  inbox: "Inbox",
  pending: "Pending",
  withdrawals: "Withdrawals",
  transactionLog: "Transactions",

  // ========== TRANSACTION LOG ==========
  totalTransactions: "Total Transactions",
  pointsIn: "Points In",
  pointsOut: "Points Out",
  filters: "Filters",
  hideFilters: "Hide",
  showFilters: "Show",
  transactionType: "Type",
  searchPlaceholder: "Username or description...",
  startDate: "Start Date",
  endDate: "End Date",
  apply: "Apply",
  reset: "Reset",
  noTransactions: "No transactions found",
  transactionsWillAppear: "Point transactions from tournaments, purchases, and admin actions will appear here.",
  
  // ========== ROLE MANAGEMENT ==========
  userRoleManagement: "User Role Management",
  joinDate: 'Join Date',
  totalActiveTime: 'Total Active',
  avgDailyTime: 'Avg Daily',
  searchUsersModifyRoles: "Search for users and modify their roles in the system. Only Main Admins can change user roles.",
  searchUsers: "Search Users",
  searchByUsername: "Search by username, email, or in-game name...",
  searchResults: "Search Results",
  selectedUser: "Selected User",
  currentRole: "Current Role",
  newRole: "New Role",
  roleChangePreview: "Role Change:",
  roleChangeDescription: "Change User Role",
  reasonForChange: "Reason for Change (Optional)",
  enterReasonForRoleChange: "Enter reason for role change...",
  changeUserRole: "Change User Role",
  searchAndSelectUser: "Search and select a user to manage their role",
  rolePermissionsGuide: "Role Permissions Guide",
  fullSystemAccess: "Full system access, can manage all users and settings",
  canManageApprovers: "Can manage approvers and approve tournaments",
  canApproveTournaments: "Can approve tournaments and earn commission",
  managerAccess: "Supervisor access plus ban users and manage roles",
  verifiedSponsorAccess: "Can create giveaway and bracket tournaments",
  regularUser: "Regular user, can participate in tournaments",
  cannotBeChanged: "⚠️ Cannot be changed",
  
  // ========== POINTS MANAGEMENT ==========
  pointsManagement: "Points Management",
  searchUsersManagePoints: "Search for users and manage their points. You can add, remove, or set specific point amounts.",
  actionType: "Action Type",
  add: "Add",
  remove: "Remove",
  set: "Set",
  pointsAmount: "Points Amount",
  enterPointsAmount: "Enter points amount...",
  reasonOptional: "Reason (Optional)",
  enterReasonForPointsAdjustment: "Enter reason for points adjustment...",
  actionAdd: "Add",
  actionRemove: "Remove", 
  actionSet: "Set",
  pointsToUser: "points to",
  pointsFromUser: "points from",
  pointsForUser: "points for",
  newBalance: "New balance:",
  addPoints: "Add Points",
  removePoints: "Remove Points",
  setPoints: "Set Points",
  searchAndSelectUserPoints: "Search and select a user to manage their points",

  // ========== SEND POINTS ==========
  sendPoints: "Send Points",
  sendPointsFromWallet: "Send points from your wallet to another user",
  yourBalance: "Your Balance",
  searchRecipient: "Search Recipient",
  recipient: "Recipient",
  theirPoints: "Their Points",
  amountToSend: "Amount to Send",
  enterReasonForTransfer: "Enter reason for transfer...",
  sending: "Sending",
  yourNewBalance: "Your new balance",
  insufficientFunds: "Insufficient funds",
  searchAndSelectRecipient: "Search and select a recipient to send points",
  confirmTransfer: "Confirm Transfer",
  sendingTo: "Sending to",
  transferDetails: "Transfer Details",
  sendingAmount: "Sending",
  pointsTo: "points to",
  theirNewBalance: "Their new balance",
  transferWarning: "This transfer is immediate and cannot be undone. The points will be deducted from your wallet.",
  confirmSend: "Confirm Send",
  pointsSentSuccessfully: "Successfully sent {points} points to {username}",
  failedToSendPoints: "Failed to send points",
  pointsTransferSent: "Points Sent",
  pointsTransferReceived: "Points Received",

  // ========== COMMISSION SETTINGS ==========
  commissionRateSettings: "Commission Rate Settings",
  multiplayerTournaments: "🎯 Multiplayer Tournaments",
  battleRoyaleTournaments: "👑 Battle Royale Tournaments", 
  approverCommission: "Approver Commission (%)",
  systemCommission: "System Commission (%)",
  updateCommissionRates: "Update Commission Rates",
  updating: "Updating...",
  
  // ========== USER MANAGEMENT ==========
  allUsers: "All Users",
  ban: "Ban",
  unban: "Unban",
  
  // ========== APPROVERS MANAGEMENT ==========
  addNewApprover: "Add New Approver",
  multiplayerCommissionRange: "Multiplayer Commission (0-{max}%):",
  battleRoyaleCommissionRange: "Battle Royale Commission (0-{max}%):",
  addAsApprover: "Add as Approver",
  adding: "Adding...",
  myApprovers: "My Approvers",
  noApproversAdded: "No approvers added yet.",
  
  // ========== TOURNAMENT MANAGEMENT ==========
  matchesReadyForApproval: "Matches Ready for Approval",
  youCanOnlySeeMatches: "ℹ️ You can only see matches that haven't been claimed by other {role} or matches you previously started approving.",
  supervisors: "supervisors",
  approversLower: "approvers",
  noMatchesReady: "No matches ready for approval.",
  othersMayHaveClaimed: "Other {role} may have claimed available matches.",
  enterMatchIdFromCod: "Enter Match ID from CoD Mobile",
  approve: "Approve",
  approving: "Approving...",
  startedBy: "⚠️ Started by:",
  assignedToBot: 'Assigned to Bot',
  
  // ========== ACTIVE MATCHES ==========
  activeMatches: "Active Matches",
  youCanOnlyManageMatches: "ℹ️ You can only see and manage matches you personally approved.",
  noActiveMatches: "No active matches.",
  haventApprovedMatches: "You haven't approved any matches yet or they have been completed.",
  roomLabel: "🎮 Room ID",
  generating: "Generating...",
  noAccess: "🔒 NO ACCESS",
  notInTournament: "Not in this tournament",
  copyId: "COPY ID",
  joinRoom: "JOIN ROOM",
  roomUrl: "Room URL",
  enterRoomUrl: "https://... (optional link to join room)",
  roomUrlDescription: "If provided, players will see a 'Join Room' button",
  edit: "EDIT",
  cancel: "CANCEL",
  standby: "⏱️ STANDBY",
  activeBadge: "🔥 ACTIVE",
  joined: "✓ JOINED",
  selectWinners: "Select Winner",
  selectWinnersPlural: "Select Winners",
  readyForSelection: "⚡ Ready for selection",
  completeMatch: "Complete Match",
  completing: "Completing...",
  winner: "winner",
  winners: "winners",
  teamModeInfo: "ℹ️ {mode}: Select {count} winner{plural} from the winning team",
  duos: "Duos",
  squads: "Squads",
  teamMode: "Team",
  winnerSelectionAvailable: "⚡ Winner selection is available now. The countdown is just the deadline for players to join.",
  
  // ========== EDIT MATCH ID ==========
  editMatchId: "Edit Match ID",
  currentMatchId: "Current Match ID:",
  newMatchId: "New Match ID",
  enterNewMatchId: "Enter new Match ID from CoD Mobile",
  matchIdCannotBeEmpty: "Match ID cannot be empty",
  matchIdTooLong: "Match ID must be less than 50 characters",
  sameAsCurrentMatchId: "New Match ID is the same as current Match ID",
  validNewMatchId: "✓ Valid new Match ID", 
  matchIdHistory: "Match ID History:",
  current: "(current)",
  changingMatchIdNotification: "⚠️ Changing the Match ID will notify all tournament participants. Make sure the new Match ID is correct.",
  updateMatchId: "Update Match ID",
  updateMatching: "Updating...",
  
  // ========== CANCEL TOURNAMENT ==========
  cancelTournament: "Cancel Tournament",
  cancellationReason: "Cancellation Reason",
  enterReasonForCancelling: "Enter reason for cancelling this tournament...",
  refundInformation: "⚠️ Refund Information:",
  creatorWillReceive: "The creator will receive",
  pointsBack: "points back",
  eachParticipantWillReceive: "Each participant will receive their",
  entryFeeBack: "entry fee back",
  totalRefund: "Total refund",
  giveawayIndicator: "🎁 Giveaway Tournament",
  thisActionCannotBeUndone: "⚠️ This action cannot be undone. All participants will be refunded and the tournament will be permanently cancelled.",
  confirmCancellation: "Confirm Cancellation",
  cancelling: "Cancelling...",
  keepTournament: "Keep Tournament",
  
  // ========== WITHDRAWAL REQUESTS ==========
  withdrawalRequests: "Withdrawal Requests",
  noPendingRequests: "No pending requests.",
  pointsToAmount: "{points} Points → ${amount}",
  
  // ========== CONFIRMATION MODALS ==========
  confirmRoleChange: "Confirm Role Change",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ This action will immediately change the user's role and permissions. The user will be notified of this change.",
  confirmChange: "Confirm Change",
  changingRole: "Changing Role...",
  
  // ========== POINTS CONFIRMATION ==========
  confirmPointsAction: "Confirm Points {action}",
  pointsAction: "Action:",
  actionDescription: "{action} {amount} points {preposition} {username}",
  prepositionTo: "to",
  prepositionFrom: "from", 
  prepositionFor: "for",
  thisActionWillUpdatePoints: "⚠️ This action will immediately update the user's points balance. Make sure the amount is correct.",
  confirmAction: "Confirm {action}",
  processing: "Processing...",
  
  // ========== GENERAL CONFIRMATION ==========
  changeUserRoleQuestion: "Change role?",
  banUserQuestion: "Ban user?",
  unbanUserQuestion: "Unban user?",
  removeApproverQuestion: "Remove approver?",
  
  // ========== NOTIFICATIONS & MESSAGES ==========
  roleChangedSuccessfully: "Successfully changed {username}'s role to {role}",
  pointsAddedSuccessfully: "Successfully added {points} points to {username}",
  pointsRemovedSuccessfully: "Successfully removed {points} points from {username}",
  pointsSetSuccessfully: "Successfully set {points} points for {username}",
  matchIdUpdatedSuccessfully: "Match ID updated successfully",
  tournamentCancelledSuccessfully: "Tournament cancelled successfully. {refundInfo}",
  commissionRatesUpdated: "Commission rates updated successfully!",
  userBannedSuccessfully: "{username} has been banned successfully!",
  userUnbannedSuccessfully: "{username} has been unbanned successfully!",
  approverAddedSuccessfully: "Approver added successfully!",
  approverRemovedSuccessfully: "{username} removed from approver role successfully!",
  matchApprovedSuccessfully: "Match approved successfully!",
  matchCompletedSuccessfully: "Match completed successfully!",
  withdrawalProcessedSuccessfully: "Withdrawal request {status} successfully!",
  
  // ========== ERROR MESSAGES ==========
  failedToLoadAdminData: "Failed to load admin data",
  failedToChangeUserRole: "Failed to change user role",
  failedToManagePoints: "Failed to manage points",
  failedToUpdateMatchId: "Failed to update match ID",
  failedToCancelTournament: "Failed to cancel tournament",
  failedToUpdateCommissionRates: "Failed to update commission rates",
  failedToProcessWithdrawal: "Failed to process withdrawal",
  failedToSearchUsers: "Failed to search users",
  invalidUserOrRole: "Invalid user or role selection",
  userAlreadyHasRole: "User already has this role",
  pleaseSelectUser: "Please select a user first",
  pleaseEnterValidAmount: "Please enter a valid points amount",
  pleaseEnterMatchId: "Please enter a Match ID!",
  pleaseSelectWinner: "Please select at least one winner!",
  unknownAction: "Unknown action: {action}",
  
  // ========== FORM LABELS & PLACEHOLDERS ==========
  searchResultsHeader: "Search Results ({count})",
  
  // ========== STATUS INDICATORS ==========
  banned: "BANNED",
  approved: "APPROVED",
  rejected: "REJECTED",
  
  // ========== TOURNAMENT CREATION ==========
  upTo: 'Up to',
  createTournament: "Create Tournament",
  tournamentType: "Tournament Type",
  regularTournament: "🏆 Regular Tournament",
  giveawayTournament: "🎁 Giveaway Tournament (Free Entry)",

  // Giveaway Creator Participation Options
  creatorParticipation: "Your Participation",
  joinAndPlay: "Join & Play",
  joinAndPlayDesc: "You participate in the match",
  spectateGame: "Spectate Game",
  spectateGameDesc: "Watch the match as spectator",
  sponsorOnly: "Sponsor Only",
  sponsorOnlyDesc: "Just fund the prize, others play",
  spectateInfo: "You will be in the game as a SPECTATOR. You can watch but not play. All player slots are open for others.",
  sponsorInfo: "You will NOT be added to the match. All slots are open for other players to join freely.",
  spectator: "SPECTATOR",
  gameMode: "Game Mode",
  multiplayerType: "Match Type",
  battleRoyaleType: "Battle Royale Type",
  teamMatch: "Team Match",
  customMode: "Custom Mode",
  solo: "Solo",
  duo: "Duo",
  squad: "Squad",
  team: "Team",
  entryFee: "Entry Fee",
  totalPrizePool: "Total Prize Pool",
  roomPassword: "Room Password",
  optional: "Optional",
  estimatedPrizePool: "Estimated Prize Pool",
  totalEntryFees: "Total Entry Fees",
  commission: "Commission",
  yourEntryFee: "Your Entry Fee",
  yourTotalCost: "Your Total Cost",
  entryFeeForPlayers: "Entry Fee for Players",
  insufficientPoints: "Insufficient points!",
  createTournamentBtn: "Create Tournament",
  createRegularTournament: "Create Tournament",
  createGiveawayTournament: "Create Giveaway Tournament", 
  createQuickSolo: "Create Quick Solo",
  creating: "Creating...",
  minimize: "Minimize",
  expandChat: "Expand chat",
  minimizeChat: "Minimize chat",
  closeChat: "Close chat",
  prizePoolForWinners: "Prize Pool for Winners",
  howItWorks: "How it works",
  howItWorksQuickSolo: "Quick 1v1 match on Shipment. First to {kills} kills or highest score at {time} wins!",
  howItWorksGiveaway: "You pay {cost} points ({prize} prize + {commission} commission). Players join for free. Winner(s) receive exactly {prizePool} points.",
  howItWorksRegular: "Total entry fees: {totalEntry} pts. After {commissionRate}% commission, prize pool is {prizePool} pts.",
  locked: "Locked",
  
  // ========== QUICK SOLO SPECIFIC ==========
  quickSolo: "⚡ Quick Solo (1v1)",
  quickSoloTournament: "Quick Solo Tournament",
  killLimit: "Kill Limit",
  timeLimit: "Time Limit",
  timeLimitSeconds: "Time Limit (seconds)",
  weaponRestrictions: "Weapon Restrictions (Optional)",
  selectAllowedWeapons: "Select allowed weapon types (leave empty for all weapons)",
  selectedWeapons: "Selected Weapon Types",
  allWeaponsAllowed: "All weapons allowed - no restrictions applied",
  weaponRestrictionsWarning: "⚠️ Using restricted weapons will result in instant disqualification!",
  allowedWeaponsOnly: "Only these weapons are allowed:",
  quickSoloInfo: "Quick Solo: Fast-paced 1v1 matches on Shipment only. Perfect for quick point battles!",
  
  // ========== WEAPON TYPES ==========
  boltActionSniper: "Bolt-Action Sniper/Marksman",
  shotgun: "Shotgun", 
  assault: "Assault",
  smg: "SMG",
  
  // ========== TOURNAMENT STATUSES ==========
  lobby: "LOBBY",
  wait: "WAIT", 
  activeStatus: "ACTIVE",
  finish: "FINISH",
  deploying: "DEPLOYING",
  standbyStatus: "STANDBY",
  completed: "COMPLETED",
  cancelled: "CANCELED",
  autoCanceled: "AUTO-CANCELED",
  
  // ========== TOURNAMENT ACTIONS ==========
  join: "JOIN",
  abort: "ABORT",
  copy: "COPY",
  deploy: "DEPLOY",

  // ========== BR TEAM JOIN MODAL ==========
  selectTeamPreference: "Select Team Preference",
  selectTeam: "Select Your Team",
  preference: "Preference",
  soloTournament: "Solo Tournament",
  soloTournamentDesc: "This tournament requires all players to play alone. No teammates allowed.",
  randomTournament: "Open Team Tournament",
  randomTournamentDesc: "Any player can join and team up with others. Choose your team preference below.",
  squadTournament: "Squad Tournament",
  squadTournamentDesc: "The creator has specified squadmates. You can form your own squad or join as random.",
  teamTournament: "Team Tournament",
  creatorSquadmates: "Creator's Squadmates:",
  duoTeamInfo: "Choose how you want to play in this Duo tournament",
  squadTeamInfo: "Choose how you want to play in this Squad tournament",
  yourTeamPreference: "Your Team Preference",
  soloTeam: "👤 Solo - No teammates",
  soloLockedReason: "Tournament creator set this to Solo mode - all players must play alone.",
  randomTeam: "🎲 Random - Any player can join",
  squadTeam: "👥 Squad - Choose specific teammates",
  selectSquadmates: "Select Squadmates",
  randomPlayer: "🎲 Random Player",
  playerName: "Player Name",
  specific: "Specific Player",
  squadHelpText: "Toggle between specific player name, random player, or empty slot",
  soloInfo: "You will play alone. No one can join your team.",
  randomInfo: "Any available player can join your team.",
  selectTeamToJoin: "Select which team you want to join. Teams marked as unavailable have restrictions.",
  randomPreference: "Random Teammate Preference",
  squadPreference: "Squad Preference",
  noAvailableTeams: "No available teams to join. All teams are full or have restrictions.",
  soloPlayerTeam: "Solo Player",
  squadOnly: "Squad Only",
  available: "Available",
  spot: "spot",
  spots: "spots",
  back: "Back",

  // ========== MP TEAM SELECTION ==========
  captainSettings: "Team Captain Settings",
  captainSettingsInfo: "As team captain, choose who can join your team",
  teamJoinMode: "Team Join Mode",
  randomTeammates: "Random - Anyone can join",
  specificTeammates: "Specific - Choose teammates",
  selectTeammates: "Select Teammates (by In-Game Name)",
  slot: "Slot",
  clickToEmpty: "Click to leave empty",
  clickForRandom: "Click for random",
  setRandom: "Set Random",
  enterInGameName: "Enter in-game name",
  anyPlayerCanJoin: "Any player can join this slot",
  teammatesNote: "Leave empty slots to prevent others from joining your team",
  randomTeamInfo: "Any player will be able to join your team",
  youWillBeCaptain: "You will be the team captain",
  youAreInvited: "You are invited to this team",
  joiningViaRandomSlot: "Joining via random slot",
  teamNotAccepting: "This team is not accepting players",
  notOnInviteList: "You are not on the invite list for this team",
  invitedPlayers: "Invited players:",
  createTeam: "Create Team",
  mpTeamSelectInfo: "Choose which team to join for this match",
  teamRestriction: "Team Restriction",
  teamSelectionHeading: "Team Selection",
  randomTeam: "Random Team",
  specificTeam: "Specific Team",

  // ========== TOURNAMENT DETAILS ==========
  giveaway: "GIVEAWAY",
  highStakes: "HIGH STAKES",
  veryHighStakes: "VERY HIGH STAKES",
  legendaryStakes: "LEGENDARY STAKES",
  passwordProtected: "🔒PWD",
  roomId: "🎮 ROOM",
  matchLive: "MATCH LIVE",
  tournamentId: "Tournament ID",
  copyTournamentId: "Copy Tournament ID",
  
  // ========== TOURNAMENT OPERATIONS ==========
  tournamentOps: "TOURNAMENT OPS",
  intelUpdated: "Intel updated!",
  noActiveLobies: "NO ACTIVE LOBBIES",
  deployFirstTournament: "Deploy the first tournament!",
  noPendingDeployments: "NO PENDING DEPLOYMENTS",
  fullLobbiesAppear: "Full lobbies will appear here (auto-cancel after 30min)",
  noActiveOperations: "NO ACTIVE OPERATIONS",
  deployedTournamentsAppear: "Deployed tournaments will appear here",
  noCompletedMissions: "NO COMPLETED MISSIONS",
  finishedCancelledAppear: "Finished and cancelled tournaments will appear here",
  noData: "NO DATA",
  nothingToShow: "Nothing to show",
  refresh: "REFRESH",
  
  // ========== CHAT SYSTEM ==========
  chat: "Chat",
  searchPlayers: "Search players...",
  noPlayersOnline: "No other players online",
  noPlayersMatch: "No players match your search",
  sendMessage: "Send",
  messageUser: "Message",
  typing: "typing...",
  connected: "Connected to server!",
  hasUnread: "has unread",
  newMessage: "New Message",
  from: "from",
  in: "in",
  
  // ========== POINTS & PROFILE ==========
  estimatedValue: "Estimated Value", 
  buyPoints: "Buy Points",
  withdraw: "Withdraw",
  minimumWithdrawal: "Minimum withdrawal amount is 1000 points ($9.50)",
  profileManagement: "Profile Management",
  editProfile: "Edit Profile",
  changePassword: "Change Password",
  updateProfile: "Update Profile",
  
  // ========== WITHDRAWAL ==========
  requestWithdrawal: "Request Withdrawal",
  pointsToWithdraw: "Points to Withdraw",
  paypalEmail: "PayPal Email",
  youllReceive: "You'll receive",
  platformFee: "platform fee",
  withdrawalInfo: "Withdrawal Info",
  minimum: "Minimum",
  submitRequest: "Submit Request",
  withdrawalMinimum: "Minimum: 1000 points ($9.50)",
  withdrawalFee: "Platform fee: 5%",
  withdrawalProcessing: "Processing: 24-96 hours",
  feePercent: "5% fee",
  info: "Info",
  submitting: "Submitting...",
  submitting: "Submitting...",
  leaveEmptyToUse: "Leave empty to use your account email",
  withdrawalHistory: "Withdrawal History",
  noWithdrawalRequests: "No withdrawal requests yet.",
  note: "Note",
  
  // ========== PROFILE MANAGEMENT ==========
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  enterCurrentPassword: "Enter your current password",
  enterNewPassword: "Enter new password (min 6 characters)",
  confirmYourNewPassword: "Confirm your new password",
  passwordsMatch: "✓ Passwords match",
  passwordsDoNotMatch: "✗ Passwords do not match",
  securityTips: "Security Tips",
  useAtLeast8Characters: "Use at least 8 characters",
  includeUppercaseLowercase: "Include uppercase and lowercase letters",
  addNumbersSpecialChars: "Add numbers and special characters",
  dontUsePersonalInfo: "Don't use personal information",
  changing: "Changing...",
  makesSureThisMatches: "⚠️ Make sure this matches your exact CoD Mobile in-game name!",
  passwordStrength: "Password Strength",
  weak: "Weak",
  medium: "Medium",
  strong: "Strong",
  useUppercaseLowercase: "Use uppercase, lowercase, numbers, and symbols for a stronger password",
  testCurrentPassword: "Test Current Password",
  
  // ========== MATCH HISTORY ==========
  yourMatchHistory: "Your Match History",
  noCompletedMatches: "No completed matches yet.",
  joinTournamentsHistory: "Join tournaments to build your match history!",
  entryFeeLabel: "Entry",
  prizeLabel: "Prize",
  dateLabel: "Date",
  match: "Match",
  mode: "Mode",
  date: "Date",
  pts: "pts",
  split: "Split",
  ways: "ways",
  loadingMatchHistory: "Loading match history...",
  
  // ========== INBOX SYSTEM ==========
  supportInbox: "Support Inbox", 
  newReport: "New Report",
  submitNewSupportReport: "Submit New Support Report",
  subject: "Subject",
  description: "Description",
  submitReport: "Submit Report",
  noCasesYet: "No support cases yet",
  createNewReport: "Create a new report if you need assistance with tournaments, payments, or account issues.",
  submitFirstReport: "Submit Your First Report",
  open: "Open",
  closed: "Closed",
  beforeSubmitting: "Before submitting:",
  beAsDetailed: "• Be as detailed as possible in your description",
  includeRelevantUsernames: "• Include any relevant usernames or tournament IDs",
  supportTeamWillReview: "• Our support team will review and respond within 24 hours",
  minimumCharactersRequired: "Minimum 5 characters required",
  minimum10CharactersRequired: "Minimum 10 characters required",
  submissionProcess: "Submission Process:",
  reportWillBeSubmitted: "Your report will be submitted as closed initially and reviewed by our support team. Once reviewed, they may reopen it to allow further communication if needed.",
  typeYourMessage: "Type your message...",
  send: "Send",
  pressEnterShift: "Press Enter + Shift for new line",
  caseNumber: "Case",
  updated: "Updated",
  messages: "messages",
  clickToView: "Click to view conversation",
  thisCaseIsClosed: "This case is closed. You cannot respond to closed cases.",
  activeMatchDetails: "Active Match Details",
  matchSettings: "🏆 Match Settings",
  teamMembers: "👥 Team Members",
  type: "Type",
  
  // ========== ADMIN INBOX PANEL TRANSLATIONS ==========
  supportInboxManagement: "Support Inbox Management",
  createCase: "Create Case", 
  totalCases: "Total Cases",
  openCases: "Open Cases",
  closedCases: "Closed Cases",
  allStatus: "All Status",
  allAssignments: "All Assignments", 
  unassigned: "Unassigned",
  assignedToMe: "Assigned to Me",
  loadingCases: "Loading cases...",
  noCasesFound: "No cases found",
  adjustFiltersOrCreateCase: "Adjust filters or create a new case for a user",
  
  // Missing core translations
  unknown: "Unknown",
  mins: "m",
  hrs: "h",
  daysShort: "d", 
  ago: "ago",
  warning: "Warning",
  view: "View",
  viewCase: "View",
  created: "Created",
  createNewCaseForUser: "Create New Case for User",
  selectUser: "Select User",
  searchUsersUsername: "Search users by username, email, or in-game name...",
  selected: "Selected:",
  initialMessage: "Initial Message",
  caseSubject: "Case subject...",
  initialMessageToUser: "Initial message to the user...",
  createCaseBtn: "Create Case",
  closeCase: "Close Case",
  openCase: "Open Case",
  assignToMe: "Assign to Me",
  unassignCase: "Unassign",
  deleteCase: "Delete Case",
  assignedTo: "Assigned to:",
  systemMessage: "System",
  typeYourResponse: "Type your response...",
  deleteCaseModal: "Delete Case",
  deleteCaseWarning: "Warning:",
  deleteCaseText: "This action cannot be undone. The case and all its messages will be permanently deleted.",
  deleting: "Deleting...",
  youAreCurrentlyViewing: "📝 You are currently viewing this case",
  youAreViewingCasesList: "📋 You are viewing the cases list",
  afterDeletionReturn: "After deletion, you will return to the cases list",
  listWillRefresh: "The list will refresh after deletion",
  caseLabel: "Case:",
  userLabel: "User:",
  messagesLabel: "Messages:",
  newReportFrom: "New report from {user}: {subject}",
  newMessageInCase: "New message in case {caseNumber}",
  caseAssignedToYou: "Case {caseNumber} assigned to you",
  pleaseFillAllFields: "Please fill in all fields",
  caseCreatedSuccessfully: "Case created successfully",
  failedToCreateCase: "Failed to create case",
  pleaseEnterMessage: "Please enter a message",
  failedToSendMessage: "Failed to send message",
  caseStatusSuccessfully: "Case {status} successfully",
  failedToUpdateCaseStatus: "Failed to update case status",
  caseAssignedSuccessfully: "Case assigned successfully",
  caseUnassignedSuccessfully: "Case unassigned successfully",
  failedToAssignCase: "Failed to assign case",
  caseDeletedSuccessfully: "Case deleted successfully",
  failedToDeleteCase: "Failed to delete case",
  noCaseSelectedForDeletion: "No case selected for deletion",
  noCaseSelected: "No case selected",
  reasonForClosing: "Reason for closing this case:",
  reasonForOpening: "Reason for opening this case:",
  closing: "closing",
  opening: "opening",
  assignment: "Assignment",
  user: "User",
  createdLabel: "Created",
  updatedLabel: "Updated",
  emptyStateTitle: "No cases found",
  emptyStateText: "Adjust filters or create a new case for a user",
  
  // ========== INBOX ERROR MESSAGES ==========
  failedToLoadInbox: "Failed to load inbox",
  failedToLoadCase: "Failed to load case", 
  pleaseFillBothFields: "Please fill in both subject and description",
  subjectMinLength: "Subject must be at least 5 characters",
  descriptionMinLength: "Description must be at least 10 characters",
  reportSubmittedSuccessfully: "Report submitted successfully",
  failedToSubmitReport: "Failed to submit report",
  messageTooLong: "Message too long (max 1000 characters)",
  briefDescriptionPlaceholder: "Brief description of your issue...",
  detailedDescriptionPlaceholder: "Please provide detailed information about your issue, including any relevant usernames, tournament IDs, or steps to reproduce the problem...",
  hasBeenLabel: "has been",
  reopened: "reopened",
  yourCase: "Your case",
  hasBeenDeleted: "has been deleted by",
  
  // ========== PAYMENT SYSTEM ==========
  buyTournamentPoints: "Buy Tournament Points",
  chooseYourPerfectPackage: "Choose your perfect package and start competing!",
  selectYourPackage: "Select Your Package",
  chooseTheAmountOfPoints: "Choose the amount of points that fits your gaming needs",
  instantDelivery: "Instant delivery",
  securePayment: "Secure payment",
  noExpiration: "No expiration",
  securePaymentInfo: "Secure Payment Information",
  processingPayment: "Processing Payment...",
  yourPaymentProcessedSecurely: "Your payment is processed securely by PayPal",
  pointsAddedInstantly: "Points are added to your account instantly",
  allTransactionsEncrypted: "All transactions are encrypted and secure",
  noHiddenFeesOrCharges: "No hidden fees or charges",
  pointsPerDollar: "points per $",
  
  // ========== PAYMENT PACKAGE DESCRIPTIONS ==========
  perfectForTryingOut: "Perfect for trying out",
  bestValueForBeginners: "Best value for beginners",
  seriousPlayersChoice: "Serious players choice",
  tournamentReady: "Tournament ready",
  competitiveEdge: "Competitive edge",
  proTournamentBundle: "Pro tournament bundle",
  maximumValuePack: "Maximum value pack",
  
  // ========== PACKAGE BADGES ==========
  starter: "Starter",
  basic: "Basic",
  mostPopular: "Most Popular",
  greatValue: "Great Value",
  powerPack: "Power Pack",
  ultimate: "Ultimate",
  megaPack: "Mega Pack",
  
  // ========== PURCHASE INSTRUCTIONS ==========
  howToPurchase: "How to Purchase",
  selectPackage: "Select Package",
  chooseYourPreferredPackage: "Choose your preferred points package above",
  clickPayPal: "Click PayPal",
  proceedWithSecureCheckout: "Proceed with secure PayPal checkout",
  completePayment: "Complete Payment",
  finishTransactionViaPayPal: "Finish transaction via PayPal",
  pointsAddedImmediatelyToAccount: "Points added immediately to your account",
  
  // ========== TOURNAMENT MODES ==========
  snipersOnly: "SNIPERS ONLY",
  rifleOnly: "RIFLES ONLY",
  knifeOnly: "MELEE ONLY", 
  executionOnly: "EXECUTION ONLY",
  grenadesOnly: "EXPLOSIVES ONLY",
  snipers: "SNIPERS",
  rifles: "RIFLES",
  melee: "MELEE",
  execution: "EXECUTION",
  explosives: "EXPLOSIVES",
  custom: "Custom",
  ffa: "FFA",
  
  // ========== GAME MODES ==========
  teamDeathmatch: "⚔️ Team Deathmatch",
  domination: "🏁 Domination",
  searchAndDestroy: "💣 Search & Destroy",
  hardpoint: "📍 Hardpoint",
  killConfirmed: "🏷️ Kill Confirmed",
  captureTheFlag: "🚩 Capture the Flag",
  frontline: "⚡ Frontline",
  freeForAll: "🎯 Free for All",
  gunGame: "🔫 Gun Game",
  sticksAndStones: "Sticks & Stones",
  oneShotOneKill: "🎯 One Shot One Kill",
  cranked: "⚡ Cranked",
  rapidFire: "💨 Rapid Fire",
  attackOfTheUndead: "🧟 Attack of the Undead",
  
  // ========== GENERAL LABELS ==========
  tournament: "Tournament",
  random: "Random",
  
  // ========== MAPS ==========
  randomMap: "🎲 Random Map",
  
  // ========== PASSWORD MODAL ==========
  passwordProtectedTournament: "🔒 PASSWORD PROTECTED TOURNAMENT 🔒",
  tournamentPasswordProtected: "This tournament is password protected. You need the correct password to join.",
  enterPassword: "Enter Password",

  // ========== BAN MODAL ==========
  accountBanned: "🚫 Account Banned 🚫",
  accountBannedDesc: "Your account has been banned and cannot login.",
  bannedBy: "Banned by",
  contactSupport: "Contact support if you believe this is an error.",
  understood: "Understood",
  
  // ========== FORM VALIDATION ==========
  fieldRequired: "This field is required",
  invalidEmail: "Please enter a valid email address",
  passwordTooShort: "Password must be at least 6 characters",
  usernameMinLength: "Username must be at least 3 characters",
  usernameMaxLength: "Username must be less than 20 characters",
  invalidCharacters: "Contains invalid characters",
  fieldTooLong: "This field is too long",
  fieldTooShort: "This field is too short",
  numberRequired: "Please enter a valid number",
  numberTooLow: "Number is too low",
  numberTooHigh: "Number is too high",
  
  // ========== GENERAL ERRORS & MESSAGES ==========
  error: "Error",
  success: "Success",
  info: "Info",
  failed: "Failed",
  retry: "Retry",
  confirm: "Confirm",
  
  // ========== GENERAL ACTIONS ==========
  save: "Save",
  delete: "Delete",
  update: "Update",
  submit: "Submit",
  reject: "Reject",
  
  // ========== MISSING ADMIN TRANSLATIONS ==========
  banUser: "Ban User",
  unbanUser: "Unban User",
  removeApprover: "Remove Approver",
  failedToApproveMatch: "Failed to approve match",
  failedToCompleteMatch: "Failed to complete match",
  startsIn: "Starts in",
  
  // ========== TIME & DATES ==========
  now: "now",
  today: "today",
  yesterday: "yesterday",
  timeUntilAutoCancel: "min until auto-cancel",
  timeRemaining: "min remaining",
  
  // ========== NOTIFICATIONS ==========
  tournamentCreated: "Tournament created successfully!",
  joinedTournament: "Joined tournament successfully!",
  leftTournament: "Left tournament successfully!",
  profileUpdated: "Profile updated successfully!",
  passwordChanged: "Password changed successfully!",
  connectionRestored: "Server connection restored",
  reconnecting: "Reconnecting to server...",
  tournamentApproved: "Tournament approved by",
  tournamentCompleted: "Tournament completed by",
  tournamentCancelled: "Tournament cancelled by",
  tournamentAutoCancelled: "Tournament auto-cancelled: {tournamentName}",
  createdGiveawayTournament: "created a GIVEAWAY tournament in the lobby!",
  createdNewMatch: "created a new match in the lobby!",
  isNowOnline: "is now online!",
  commissionDistributed: "Commission distributed!",
  commissionUpdated: "Commission settings updated!",
  
  // ========== ADDITIONAL STRINGS ==========
  participants: "Participants",
  showParticipants: "Show Participants",
  hideParticipants: "Hide Participants",

  // ========== BRACKET/MULTISTEP TOURNAMENT ==========
  multistepTournaments: "Multistep Tournaments",
  multistepTournament: "Multiplayer Multistep Tournament",
  createBracketTournament: "Create Multistep Tournament",
  createBracket: "Create",
  noBracketTournaments: "No bracket tournaments yet",
  bracketTournamentCreated: "Bracket tournament created!",
  numberOfTeams: "Number of Teams",
  costSummary: "Cost Summary",
  prizePerWinner: "Prize per Winner",
  needMore: "Need",
  morePoints: "more points",
  confirmCreate: "Confirm Tournament Creation",
  viewBracket: "Bracket",
  tournamentBracket: "Tournament Bracket",
  joinedTeam: "Joined team successfully!",
  tournamentStarted: "Tournament started!",
  confirmWinner: "Set this team as winner?",
  yourTeam: "Your Team",
  registration: "REGISTRATION",
  final: "Final",
  semiFinals: "Semi-Finals",
  quarterFinals: "Quarter-Finals",
  round: "Round",
  matches: "matches",
  tbd: "TBD",
  clickToSelectWinner: "Click team to select winner",
  perWinner: "Per Winner",
  tournamentWinners: "Tournament Winners",
  full: "FULL",
  showTeams: "Show Teams",
  hideTeams: "Hide Teams",
  startTournament: "Start",
  // Additional Bracket Tournament Keys
  viewAllTeams: "All Teams & Matchups",
  allTeamsMatchups: "All Teams & Matchups",
  teams: "Teams",
  activeBracketMatches: "Active Bracket Matches",
  configureMatch: "Configure Match",
  configureMatchups: "Configure Matchups",
  startMatch: "Start Match",
  applications: "Applications",
  pendingTeams: "Pending Teams",
  approvedTeams: "Approved Teams",
  pendingApplications: "Pending Applications",
  noApplications: "No pending applications",
  noApprovedTeamsYet: "No approved teams yet",
  pendingTeamsApproval: "Pending Teams Approval",
  pendingTeamsInfo: "These teams are waiting for approval",
  approveTeam: "Approve",
  rejectTeam: "Reject",
  teamApproved: "Team approved!",
  teamRejected: "Team rejected and removed",
  applicationApproved: "Application approved!",
  applicationRejected: "Application rejected",
  errorApprovingTeam: "Error approving team",
  errorRejectingTeam: "Error rejecting team",
  errorApproving: "Error approving application",
  errorRejecting: "Error rejecting application",
  applyToTournament: "Apply to Tournament",
  applyToJoin: "Apply to Join",
  applyToTeam: "Apply",
  applying: "Applying...",
  applied: "Applied",
  teamApplied: "Team application submitted! Awaiting admin approval.",
  applicationSubmitted: "Application submitted! Waiting for admin approval.",
  applicationPending: "Your application to",
  isPending: "is pending approval",
  awaitingApproval: "Awaiting Approval",
  createNewTeam: "Create New Team",
  youAreCaptain: "You are the Team Captain!",
  captainInfo: "As team captain, you can set preferences for who can join your team.",
  teamPreferences: "Team Preferences",
  setPreferencesFirst: "Select Team First",
  captain: "Captain",
  teamName: "Team Name",
  enterTeamName: "Enter team name",
  teammates: "Teammates",
  teammate: "Teammate",
  teammatesHint: "Enter the usernames of your 4 teammates",
  teammatesUpdated: "Teammate names updated!",
  editTeammates: "Edit teammate names",
  editTeammateNames: "Edit Teammate Names",
  editNames: "Edit Names",
  editHint: "Update the usernames of your teammates",
  saveChanges: "Save Changes",
  saving: "Saving...",
  need4Teammates: "You must specify all 4 teammates",
  needMoreTeammates: "You need more teammate names",
  duplicateNames: "Teammate names must be unique",
  dontIncludeYourself: "Don't include yourself in the teammate list",
  errorCreatingTeam: "Error creating team",
  errorUpdating: "Error updating teammates",
  yourAllowedSquadmates: "Your Allowed Squadmates",
  noSquadmatesSet: "No squadmates set - anyone can join your team",
  edit: "Edit",
  save: "Save",
  saving: "Saving...",
  joinThisTeam: "Join Team",
  joinYourTeam: "Join Your Team",
  leaveTeam: "Leave Team",
  confirmLeave: "Are you sure you want to leave?",
  errorJoining: "Error joining team",
  errorLeaving: "Error leaving",
  kickPlayer: "Remove player",
  kickTeam: "Kick/Disqualify Team",
  playerKicked: "Player removed from team",
  teamKicked: "Team has been kicked",
  confirmKick: "Remove this player from your team?",
  enterKickReason: "Enter reason for kicking/disqualifying this team:",
  errorKicking: "Error removing player",
  errorKickingTeam: "Error kicking team",
  invited: "Invited",
  inviteOnly: "Invite Only",
  yourNameInvited: "Your name must be in the invited list to join",
  waiting: "waiting",
  waitingToJoin: "waiting to join",
  captain: "Captain",
  totalSlots: "Total Slots",
  alreadyJoined: "Already Joined",
  allTeamsTaken: "All Teams Taken",
  teamsReady: "teams ready",
  teamsWaitingForYou: "Teams waiting for you",
  applyHint: "Apply to join an existing team or create your own",
  applyHintAdmin: "Create teams and configure matchups",
  createHintFull: "All team slots are filled",
  enterRoomId: "Enter Room ID",
  customMap: "Custom Map",
  enterCustomMapName: "Enter custom map name",
  matchStarted: "Match started!",
  errorStartingMatch: "Error starting match",
  confirmStart: "Start the tournament? Teams will be locked.",
  errorStarting: "Error starting tournament",
  selectWinner: "Select Winner",
  errorSettingWinner: "Error setting winner",
  cancelReason: "Reason for cancellation:",
  errorCancelling: "Error cancelling",
  firstRoundMatchups: "First Round Matchups",
  matchupHint: "Configure which teams face each other",
  saveMatchups: "Save Matchups",
  selectBothTeams: "Please select both teams for all matches",
  duplicateTeam: "Each team can only be used once",
  matchupsConfigured: "Matchups configured successfully!",
  errorConfiguringMatchups: "Error configuring matchups",
  adjustSizeTo: "Adjust to",
  confirmAdjustSize: "Adjust bracket size? This will regenerate the bracket structure.",
  bracketAdjusted: "Bracket adjusted",
  errorAdjustingSize: "Error adjusting bracket size",
  allTeamsApproved: "All teams approved",
  approveAllTeams: "Approve All Teams",
  confirmApproveAll: "Approve all pending teams?",
  reroll: "Reroll",
  rerollMatchup: "Random swap",
  other: "Other",
  otherMatchup: "Select team to swap",
  selectTeamToSwap: "Select team to swap with:",
  teamSwapped: "Team swapped!",
  errorSwappingTeam: "Error swapping team",
  or: "or",
  fillAllFields: "Please fill in all fields",
  required: "Required",
  prizeSummary: "Prize Summary",
  freeForAdmins: "Free to create for admins",
  gameModePerMatch: "Game mode and map are configured for each match individually",
  each: "each",
  starting: "Starting...",
  pendingApproval: "pending",

  insufficientPointsDetailed: "Insufficient points! You need {needed} points but only have {current} points.",
  giveawayExplanation: "In giveaway tournaments, you pay {prize} points (prize) + {commission} points (commission) = {total} total",
  disobeyingWeaponRules: "⚠️ Disobeying weapon rules will result in instant point loss!",
  estimatedPrizePoolCalculation: "Estimated Prize Pool",
  baseCommission: "🏛️ Base Commission",
  highKillBonus: "⚡ High-Kill Bonus",
  totalCommission: "📊 Total Commission",
  extraCommissionFromHighKills: "Extra {rate}% commission from high kill count goes to the approver.",
  failedToLoadTournaments: "Failed to load tournaments",
  system: "System",
  
  // ========== TOURNAMENT CARD SPECIFIC ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",
  
  // ========== WAIT TIME WARNINGS ==========
  warningAutoCancel: "⚠️ {time}min until auto-cancel",
  warningTimeRemaining: "⏰ {time}min remaining",
  
  // ========== ACTIVE MATCH ==========
  gameSettings: "Game Settings",
  prizePool: "Prize Pool",
  
  // ========== FINISHED TOURNAMENTS ==========
  autoCancel: "AUTO-CANCELED",
  canceled: "CANCELED",
  cancelledBy: "Cancelled by",
  more: "more",
  approvedBy: "Approved by",
  
  // ========== TOURNAMENT FIXES ==========
  failedToCreateTournament: "Failed to create tournament",
  matchType: "Match Type",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "Vote to Start Early",
  voteToStart: "Vote to Start Early",
  voteToStartEarly: "Vote to start tournament early",
  voteRecorded: "Vote recorded! ({current}/{total})",
  voteRemoved: "Vote removed",
  voteRequestSent: "Vote request sent to all participants!",
  voteInProgress: "Vote in progress ({current}/{total})",
  vote: "VOTE",
  earlyPrize: "Early Start",
  votesNeeded: "votes needed",
  votedPlayers: "Voted Players",
  voteRequestSentWaiting: "Vote request sent! Waiting for players...",
  voteNote: "Tournament will start automatically when all real players vote.",
  voteNoteGiveaway: "For giveaway matches, the creator must manually start the match after all votes are in.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "Team Preference",
  randomAnyPlayerCanJoin: "Random - Any player can join your team",
  specificChooseTeammates: "Specific - Choose your teammate(s)",
  emptySlotOptional: "Empty Slot (Optional)",
  enterPlayerInGameName: "Enter player in-game name",

  // ========== BR EDIT TEAM ==========
  editTeam: "Edit Team",
  viewTeam: "View Team",
  viewPlayers: "View Players",
  viewTeamPositions: "Team Positions",
  editAllowedTeammates: "Edit Allowed Teammates",
  teammatesHint: "Enter the names of players allowed to join your team. Leave empty or set to random to allow anyone.",
  mpTeammatesHint: "Enter player names to allow specific players. Use 🎲 for random players. Empty slots are locked.",
  specificPreference: "Specific Mode - Only named players can join",
  captain: "Captain",
  specific: "SPECIFIC",
  lockedSlot: "Locked Slot",
  lockedSlotInfo: "🔒 Locked - no one can join",
  openSlot: "Open Slot",
  waitingFor: "Waiting for",
  unlockSlot: "Unlock slot (allow random)",
  lockSlot: "Lock slot",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "Remove Player",
  kickPlayerConfirm: "Are you sure you want to remove this player?",
  kickFillerConfirm: "Remove this filler from the tournament?",
  removeFromTournament: "Remove from Tournament",
  kickReason: "Reason (optional)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "Team Selection",
  selectTeam: "Select Your Team",
  mpTeamSelectInfo: "Choose which team to join for this match",
  youWillBeCaptain: "You will be the team captain",
  youAreInvited: "You are invited to this team",
  joiningViaRandomSlot: "Joining via random slot",
  teamNotAccepting: "This team is not accepting players",
  squadOnly: "Squad Only",
  spotsAvailable: "spots available",
  captainSettings: "Team Captain Settings",
  captainSettingsInfo: "As team captain, choose who can join your team",
  teamJoinMode: "Team Join Mode",
  randomTeammate: "🎲 Random - Any player can join your team",
  specificTeammate: "👥 Specific - Choose your teammate(s)",
  slot: "Slot",
  clickToEmpty: "Click to leave empty",
  clickForRandom: "Click for random",
  random: "Random",
  setRandom: "Set Random",
  anyPlayerCanJoin: "Any player can join this slot",
  teammatesNote: "Leave empty slots to prevent others from joining your team",
  joining: "Joining...",
  createTeam: "Create Team",
  joinTeam: "Join Team",
  editTeamPreferences: "Edit Team Preferences",
  viewAllTeamPositions: "View All Team Positions",
  emptySlot: "Empty Slot",
  enterPlayerInGameName: "Enter player in-game name",
  enterNameOrSetRandom: "Enter name or set random",
  enterExactInGameName: "Enter the exact in-game name of your teammate, or set to random",
  editAllowedSquadmates: "Edit Allowed Squadmates",
  squadPreference: "Squad Mode - Specific teammates only",
  randomPreference: "Random Mode - Anyone can join",
  squadmatesHint: "Enter the names of players allowed to join your team. Leave empty or set to random to allow anyone.",
  slot: "Slot",
  anyoneCanJoin: "Anyone can join this slot",
  emptySlotInfo: "Empty - no one can use this slot",
  specificPlayer: "Only this player can join",
  setRandom: "Set to Random",
  clearSlot: "Clear Slot",
  randomPlayer: "Random Player",
  enterPlayerName: "Enter player name...",
  playerName: "Player Name",
  saveChanges: "Save Changes",
  saving: "Saving...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "Prize Reduction Warning",
  lobbyNotFull: "Lobby is not full ({current}/{max} players)",
  current: "Current",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "Kick",
  realPlayer: "Real Player",
  fillerPlayer: "Filler Player",
  fillerBot: "Filler Bot",
  playerWillReceiveRefund: "Player will receive {amount} points refund",
  thisActionIsPermanent: "This action is permanent",
  playerWillBeRemoved: "This player will be removed from the tournament and cannot rejoin.",
  tournamentInformation: "Tournament Information",
  currentPlayers: "Current: {current}/{max} players",
  kickParticipant: "Kick {type}",
  player: "Player",
  filler: "Filler",
  yourFiller: "Your Filler",
  youAddedThis: "You added this filler",
  othersFiller: "Someone else's filler",
  addedBySomeoneElse: "Added by another player",
  refundInformation: "Refund Information",
  playerRefund: "Player will receive {amount} points refund",
  fillerRefund: "Filler owner will receive {amount} points refund",
  fillerRefundNote: "Refund goes to the person who added the filler",
  permanentAction: "This action is permanent",
  playerKickWarning: "This player will be removed from the tournament and cannot rejoin.",
  fillerKickWarning: "This filler will be removed from the tournament and cannot be re-added.",
  tournamentInfo: "Tournament Information",
  currentParticipants: "Current: {current}/{max} players",
  currentFillers: "Fillers: {count}",
  kicking: "Kicking...",
  confirmKick: "Kick {type}",
  // Subscription translations
  weeklyPointDeals: "Weekly Point Deals",
  subscriptionDescription: "Get 50% points instantly + 50% dripping daily for 7 days",
  activePlan: "Active",
  dayProgress: "Day",
  pointsReceived: "points received",
  alreadyActive: "Already Active",
  selectPlan: "Select Plan",
  totalPoints: "TOTAL POINTS",
  instant: "instant",
  perDay: "/day",
  days: "days",
  ptsPerDollar: "pts per $1",
  perWeek: "/week",
  processingSubscription: "Processing your subscription...",
  tierBasic: "Basic",
  tierStandard: "Standard",
  tierPlus: "Plus",
  tierPremium: "Premium",
  tierMax: "Max",
  // Vendor System
  vendorPackages: "Vendor Packages",
  vendorPackagesDescription: "Purchase packages from our partner vendors",
  currentRate: "Current rate",
  selectedPackage: "Selected Package",
  purchasePackage: "Purchase Package",
  vendorNote: "The vendor will process your request and provide the package.",
  purchaseHistory: "Purchase History",
  noPurchasesYet: "No purchases yet",
  awaitingVendor: "Awaiting vendor processing",
  vendorRedeemed: "Vendor has processed your request",
  pointsRefunded: "Points have been refunded",
  packagePurchased: "Package purchased successfully!",
  purchaseFailed: "Failed to purchase package",
  // Vendor Dashboard
  dashboard: "Dashboard",
  refresh: "Refresh",
  pending: "Pending",
  redeemed: "Redeemed",
  confirmed: "Confirmed",
  cancelled: "Cancelled",
  totalValue: "Total Value",
  all: "All",
  searchCoupons: "Search coupons...",
  noCouponsFound: "No coupons found",
  redeem: "Redeem",
  cancel: "Cancel",
  delete: "Delete",
  waitingAdminConfirmation: "Waiting for admin confirmation",
  cancelCoupon: "Cancel Coupon",
  cancelWarning: "This will refund all points to the user. This action cannot be undone.",
  user: "User",
  package: "Package",
  refundAmount: "Refund Amount",
  typeCancel: "Type Cancel to confirm",
  back: "Back",
  confirmCancel: "Confirm Cancel",
  couponRedeemed: "Coupon redeemed successfully",
  couponCancelled: "Coupon cancelled and points refunded",
  couponDeleted: "Coupon deleted",
  failedToLoadCoupons: "Failed to load coupons",
  failedToRedeem: "Failed to redeem coupon",
  failedToCancel: "Failed to cancel coupon",
  failedToDelete: "Failed to delete coupon",
  pleaseTypeCancel: "Please type Cancel to confirm",
  // Admin Vendor Coupons
  vendorCoupons: "Vendor Coupons",
  owed: "Owed",
  paid: "Paid",
  redeemed: "Redeemed",
  pts: "pts",
  upToTwoWeeks: "Up to two weeks",
  upToAWeek: "Up to a week",
  minutesTo24Hours: "Minutes to 24 Hours",
  specialUpTo3Hours: "Special up to 3 hours",
  upTo48Hours: "Up to 48 Hours",
  confirmPurchase: "Confirm Purchase",
  confirmPurchaseText: "Are you sure you want to purchase this package?",
  yesPurchase: "Yes, Purchase",
  confirmRedeem: "Confirm Redeem",
  redeemConfirmText: "Are you sure you want to mark this coupon as redeemed?",
  yesRedeem: "Yes, Redeem",
  no: "No",
  couponCode: "Coupon Code",
  awaitingConfirmation: "Awaiting payment confirmation",
  confirmPayment: "Confirm Payment",
  confirming: "Confirming...",
  couponConfirmed: "Coupon confirmed successfully",
  confirmFailed: "Failed to confirm coupon",
  // ILS Rate
  vendorILSRate: "Vendor ILS Rate",
  ilsRateDescription: "Exchange rate used for vendor package pricing (ILS to USD)",
  ilsToUsdRate: "1 USD = ? ILS",
  updateILSRate: "Update ILS Rate",
  ilsRateUpdated: "ILS rate updated successfully",
  // Vendor Roles
  speedos: "SPEEDOS",
  ryder: "RYDER",
  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "MP Multistep",
  mpMultistepDesc: "Team-based multiplayer tournament with bracket progression. 5 players per team.",
  teamsCount: "4, 8, or 16 teams",
  bracketElimination: "Bracket elimination format",
  gameModePerMatch: "Game mode set per match",
  soloSquadModes: "Solo, Duo, or Squad modes",
  roundsRange: "2-5 rounds",
  cumulativePoints: "Cumulative points from kills + placement",
  pts: "pts",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "BR Multistep",
  brMultistepDesc: "Battle Royale tournament with multiple rounds",
  br_multistep: "BR Multistep",
  createBRMultistep: "Create BR Multistep Tournament",
  brMultistepCreated: "BR Multistep tournament created successfully",
// ========== FFA MULTISTEP TOURNAMENT ==========  ffaTournament: "FFA Tournament",  ffaMultistep: "FFA Tournament",  ffaMultistepDesc: "Free For All tournament with lobbies of up to 8 players. Admin approves players and picks winners.",  createFFAMultistep: "Create FFA Tournament",  ffaCreated: "FFA Tournament created!",  ffaTournamentInfo: "Free For All Tournament",  ffaInfoDesc: "Players compete in lobbies of up to 8. Winners advance to finals. Admin approves players and manually selects winners.",  maxPlayers64: "Up to 64 players",  twoRounds: "2 rounds: Lobbies + Finals",  adminApproval: "Admin approval required",  round1: "Round 1",  round1AndFinals: "Round 1 + Finals",  lobbiesOf8: "lobbies (max 8 players each)",  finals: "Finals",  grandWinner: "Grand Winner",  ptsAwarded: "pts awarded",  registration: "Registration Open",  pendingApproval: "Pending Approval",  round1Lobby: "Round 1 - Lobbies Ready",  round1InProgress: "Round 1 In Progress",  finalsLobby: "Finals Lobby Ready",  finalsInProgress: "Finals In Progress",  waitingApproval: "Waiting for admin approval...",  youAreApproved: "You are approved! Wait for tournament to start.",  requestToJoin: "Request to Join",  manageApprovals: "Manage Approvals",  pendingPlayers: "Pending Players",  approvedPlayers: "Approved Players",  noPendingPlayers: "No pending players",  noApprovedPlayers: "No approved players",  approveAll: "Approve All",  playerApproved: "Player approved!",  allApproved: "All players approved!",  playerRejected: "Player rejected",  playerRemoved: "Player removed",  confirmReject: "Reject this player?",  confirmRemove: "Remove this player?",  createLobbiesRandom: "Create Lobbies (Random)",  confirmCreateLobbies: "Create lobbies? Players will be assigned randomly.",  lobbiesCreated: "Lobbies created!",  lobbiesComplete: "Lobbies Complete",  lobby: "Lobby",  startMatch: "Start Match",  selectWinner: "Select Winner",  startFinals: "Start Finals",  selectGrandWinner: "Select Grand Winner",  winnerSelected: "Winner selected!",  confirmSelectWinner: "Select this player as the winner?",  roomId: "Room ID",  roomUrl: "Room URL",  enterRoomId: "Enter room ID",  enterRoomUrl: "Enter room URL",  roomInfoNote: "Room info will be sent to players in this match only.",  yourRoom: "Your Room",  yourFinalsRoom: "Your Finals Room",  joinRoom: "Join Room",  cancelTournament: "Cancel",  deleteTournament: "Delete",  confirmCancel: "Cancel this tournament? Prize pool will be refunded.",  confirmDelete: "PERMANENTLY DELETE this tournament? This cannot be undone!",  confirmDeleteAgain: "Are you REALLY sure? This will remove the tournament completely.",  tournamentDeleted: "Tournament deleted",  tournamentCancelled: "Tournament cancelled",  viewHistory: "View History",  matchHistory: "Match History",  noHistory: "No history yet",  playerMoved: "Player moved!",  moveFailed: "Failed to move player",  waitingToStart: "Waiting to Start",  matchInProgress: "Match In Progress",  finalsComplete: "Finals Complete",  fromLobby: "from Lobby",  joinInfo: "Your request will be reviewed by an admin.",  submitRequest: "Submit Request",  submitting: "Submitting...",  starting: "Starting...",
  solo: "Solo",
  soloDesc: "Individual players compete",
  duo: "Duo",
  duoDesc: "Teams of 2 players",
  squad: "Squad",
  squadDesc: "Teams of 4 players",
  controlMode: "Control Mode",
  control: "Control",
  manual: "Manual",
  manualDesc: "Admin manages rooms manually",
  bot: "Bot",
  botDesc: "Bot creates and manages rooms automatically",
  botIdle: "Bot Idle",
  botCreatingRoom: "Creating Room...",
  botRoomReady: "Room Ready",
  botWaitingPlayers: "Waiting for Players",
  botMatchActive: "Match in Progress",
  botExtractingResults: "Extracting Results",
  botRoundComplete: "Round Complete",
  botError: "Bot Error",
  botReconnected: "Bot reconnected",
  numberOfRounds: "Number of Rounds",
  rounds: "Rounds",
  scheduledStart: "Scheduled Start",
  scheduledStartHint: "When the tournament is scheduled to begin",
  pointsConfiguration: "Points Configuration",
  pointsPerKill: "Points Per Kill",
  perKill: "per kill",
  placementPoints: "Placement Points",
  placementHint: "Points awarded based on final placement",
  addPlacement: "Add Placement",
  place: "Place",
  pointsDistribution: "Points Distribution",
  teams: "Teams",
  allTeams: "All Teams",
  noTeamsYet: "No teams yet",
  createNewTeam: "Create New Team",
  teamName: "Team Name",
  enterTeamName: "Enter team name",
  teammates: "Teammates",
  teammate: "Teammate",
  enterTeammateNames: "Enter teammate names",
  enterAllTeammates: "Enter all teammate names",
  teamSize: "Team Size",
  teamWillHave: "Team will have",
  youPlus: "You +",
  editTeam: "Edit Team",
  editTeammatesHint: "Edit your teammates",
  editTeamNote: "You can edit your team before the tournament starts",
  teamUpdated: "Team updated successfully",
  viewTeams: "View Teams",
  yourTeam: "Your Team",
  leader: "Leader",
  joinThisTeam: "Join This Team",
  joinMyTeam: "Join My Team",
  joinMyTeamSelect: "Select a team to join",
  joinWithTeam: "Join with Team",
  selectYourTeam: "Select Your Team",
  joinedTeam: "Joined team successfully",
  leaveTeam: "Leave Team",
  duplicateTeammate: "Duplicate teammate name",
  multipleTeamsInvited: "Multiple teams can be invited",
  pendingSlots: "Pending Slots",
  manageRounds: "Manage Rounds",
  matchSettings: "Match Settings",
  editSettings: "Edit Settings",
  saveSettings: "Save Settings",
  saveChanges: "Save Changes",
  settingsSaved: "Settings saved successfully",
  confirmCreate: "Create Tournament?",
  confirmStart: "Start Tournament?",
  confirmCancel: "Cancel Tournament?",
  confirmSwitchToManual: "Switch to Manual Control?",
  switchedToManual: "Switched to manual control",
  roundStarting: "Round Starting",
  lobby: "Lobby",
  inProgress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  startsAt: "Starts at",
  joining: "Joining...",
  creating: "Creating...",
  saving: "Saving...",
  joinTournament: "Join Tournament",
  joinedTournament: "Joined tournament",
  leftTournament: "Left tournament",
  tournamentStarted: "Tournament started",
  tournamentCancelled: "Tournament cancelled",
  tournamentSummary: "Tournament Summary",
  errorCreating: "Error creating tournament",
  failedToJoin: "Failed to join tournament",
  failedToJoinTeam: "Failed to join team",
  failedToLeave: "Failed to leave tournament",
  failedToStart: "Failed to start tournament",
  failedToStartRound: "Failed to start round",
  failedToCancel: "Failed to cancel tournament",
  failedToSaveSettings: "Failed to save settings",
  failedToUpdateTeam: "Failed to update team",
  switchFailed: "Failed to switch control mode",
  commandFailed: "Command failed",
  reconnectFailed: "Reconnect failed",
  commandSent: "Command sent",
  maxPlayers: "Max Players",
  leaveEmptyForPublic: "Leave empty for public",
  optional: "Optional",
  required: "Required",
  freeForAdmins: "Free for admins",
  minPlayersRequired: "Minimum players required",
  playersNotDivisible: "Players not divisible by team size",
  selectTournamentType: "Select Tournament Type",

};

// Language configuration
export const languageConfig = {
  en: {
    name: 'English',
    flag: '🇺🇸',
    dir: 'ltr',
    nativeName: 'English'
  },

  // Withdraw Options
  chooseWithdrawMethod: 'Choose Withdrawal Method',
  selectHowToWithdraw: 'Select how you want to withdraw your points',
  withdrawPaypal: 'Withdraw via PayPal',
  withdrawPaypalDesc: 'Direct transfer to your PayPal account - Min 1,000 pts',
  speedosDesc: 'CP & Game packages',
  ryderDesc: 'CP & Game packages',
  backToOptions: 'Back to options',
  packages: 'Packages',
  contactVendor: 'Contact',
  contactOnTelegram: 'Contact on Telegram',
  afterPurchaseContact: 'After purchase, contact the vendor on Telegram:',
  ils: 'ILS',
  he: {
    name: 'Hebrew',
    flag: '🇮🇱', 
    dir: 'rtl',
    nativeName: 'עברית'
  }
};

// Main translations object for backward compatibility
export const translations = {
  en: englishTranslations
};

// Enhanced translation utility functions
export const getTranslation = (key, language = 'en', fallback = null) => {
  const translation = englishTranslations[key];
  if (translation) return translation;
  
  // Return custom fallback or the key itself
  return fallback || key;











};

export const isRTL = (language) => {
  return languageConfig[language]?.dir === 'rtl';
};

// Enhanced RTL initialization utility
export const initializeRTL = (language) => {
  const isRtl = isRTL(language);
  const htmlElement = document.documentElement;
  
  // Set direction and language attributes
  htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  htmlElement.setAttribute('lang', language);
  
  // Apply or remove RTL class
  if (isRtl) {
    htmlElement.classList.add('rtl-layout');
  } else {
    htmlElement.classList.remove('rtl-layout');
  }
  
  // Save language preference
  localStorage.setItem('preferred-language', language);
  
  console.log('🌐 RTL initialized:', {
    language,
    isRtl,
    direction: htmlElement.getAttribute('dir'),
    hasRtlClass: htmlElement.classList.contains('rtl-layout')
  });
  
  return isRtl;
};

// Utility hook for language management in components
export const useLanguageSetup = (propLanguage, propT) => {
  const [currentLanguage, setCurrentLanguage] = React.useState(() => {
    if (propLanguage) return propLanguage;
    const savedLanguage = localStorage.getItem('preferred-language');
    return savedLanguage || 'en';
  });

  const t = React.useCallback((key, fallback = null) => {
    if (propT) return propT(key, fallback);
    return getTranslation(key, currentLanguage, fallback);
  }, [propT, currentLanguage]);

  React.useEffect(() => {
    initializeRTL(currentLanguage);
  }, [currentLanguage]);

  React.useEffect(() => {
    if (propLanguage && propLanguage !== currentLanguage) {
      setCurrentLanguage(propLanguage);
    }
  }, [propLanguage]);

  return { currentLanguage, setCurrentLanguage, t };
};

// Level system specific utility functions
export const getLevelTitle = (level, language = 'en') => {
  const levelTitles = {
    1: 'Beginner', 10: 'Novice', 20: 'Intermediate', 30: 'Advanced',
    40: 'Professional', 50: 'Expert', 60: 'Master', 70: 'Grandmaster',
    80: 'Mythic', 90: 'Sage', 100: 'Legend'
  };
  
  // Find the appropriate title for the level
  const levelKeys = Object.keys(levelTitles).map(Number).sort((a, b) => b - a);
  
  for (const levelKey of levelKeys) {
    if (level >= levelKey) {
      return levelTitles[levelKey];
    }
  }
  
  return levelTitles[1]; // Default to beginner
};

export const getBadgeCategoryName = (category, language = 'en') => {
  const categoryNames = {
    'win_streak': 'Win Streak',
    'filler': 'Filler',
    'total_wins': 'Total Wins',
    'points_winning': 'Points Winning',
    'points_purchase': 'Points Purchase',
    'multiplayer': 'Multiplayer',
    'battle_royale': 'Battle Royale',
    'multiplayer_wins': 'Multiplayer Wins',
    'battle_royale_wins': 'Battle Royale Wins'
  };
  
  return categoryNames[category] || category;
};

export const getRarityName = (rarity, language = 'en') => {
  const rarityNames = {
    'common': 'Common', 'rare': 'Rare', 'epic': 'Epic', 'legendary': 'Legendary'
  };
  
  return rarityNames[rarity] || rarity;
};

// Add these utility functions for time formatting in cleanup contexts
export const formatCleanupTime = (milliseconds, language = 'en') => {
  const minutes = Math.floor(milliseconds / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  
  if (days > 0) {
    return `${days} days`;
  } else if (hours > 0) {
    return `${hours} hours`;
  } else {
    return `${minutes} minutes`;
  }
};

export const formatCleanupAge = (createdAt, language = 'en') => {
  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now - created;
  
  return formatCleanupTime(diffMs, language);
};

export const getTimeUntilCleanup = (createdAt, maxAgeHours = 1, language = 'en') => {
  const now = new Date();
  const created = new Date(createdAt);
  const maxAgeMs = maxAgeHours * 60 * 60 * 1000;
  const ageMs = now - created;
  const remainingMs = maxAgeMs - ageMs;
  
  if (remainingMs <= 0) {
    return { expired: true, timeRemaining: 0 };
  }
  
  return {
    expired: false,
    timeRemaining: remainingMs,
    formatted: formatCleanupTime(remainingMs, language)
  };
  };

// Enhanced tournament age indicator component
export const TournamentAgeIndicator = ({ tournament, language, className = '' }) => {
  const age = formatCleanupAge(tournament.createdAt, language);
  const cleanup = getTimeUntilCleanup(tournament.createdAt, 1, language);
  
  if (cleanup.expired) {
    return (
      <div className={`tournament-age-indicator expired ${className}`}>
        <span className="age-icon">⏰</span>
        <span className="age-text">Tournament automatically deleted due to age</span>
      </div>
    );
  }
  
  const isWarning = cleanup.timeRemaining < 15 * 60 * 1000; // 15 minutes
  const isCritical = cleanup.timeRemaining < 5 * 60 * 1000; // 5 minutes
  
  return (
    <div className={`tournament-age-indicator ${isWarning ? 'warning' : ''} ${isCritical ? 'critical' : ''} ${className}`}>
      <span className="age-icon">⏰</span>
      <span className="age-text">
        Tournament age: {age}
      </span>
      {isWarning && (
        <span className="cleanup-warning">
          Auto-delete in {cleanup.formatted}
        </span>
      )}
    </div>
  );};

export default englishTranslations;